var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.48 69.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grade") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a4241f44-05e9-49f8-b488-1dbb456e9bd9",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea87f236-e125-45ed-9931-ac7c2dafe19b",
    "data-name": "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.33,13.54l-4.07,27.8a16.25,16.25,0,0,1-15.53,13.55H16.59L0,69.36,4,41.89h0a3.43,3.43,0,0,1,.06-.55l4.07-27.8A16.24,16.24,0,0,1,23.71,0H144.78a12.6,12.6,0,0,1,3.53.49C153.81,2.06,157.25,7.31,156.33,13.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.33,13.54l-4.07,27.8a16.25,16.25,0,0,1-15.53,13.55H16.59L0,69.36,4,41.89h0c73.67,0,122.18-14.66,144.26-41.4C153.81,2.06,157.25,7.31,156.33,13.54Z",
    fill: "#e0e0df"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.55 14.58 34.38 22.72 43.17 24.03 35.74 30.37 35.97 39.32 28.55 35.09 19.89 39.32 22.73 30.37 17.16 24.03 26.34 22.72 31.55 14.58",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.25 14.58 68.08 22.72 76.88 24.03 69.44 30.37 69.67 39.32 62.25 35.09 53.59 39.32 56.44 30.37 50.86 24.03 60.04 22.72 65.25 14.58",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.95 14.58 101.78 22.72 110.58 24.03 103.14 30.37 103.37 39.32 95.95 35.09 87.29 39.32 90.14 30.37 84.56 24.03 93.74 22.72 98.95 14.58",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.66 14.58 135.48 22.72 144.28 24.03 136.84 30.37 137.07 39.32 129.65 35.09 120.99 39.32 123.84 30.37 118.26 24.03 127.44 22.72 132.66 14.58",
    fill: "#f77f00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.9c034814.svg";
export { ForwardRef as ReactComponent };